import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IncrediSelect } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, ref, watch } from 'vue';
import { Builds_BuildResult } from '@/graphql/codegen/generated/graphql';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { useMatomo } from '@/services/matomo/matomo.service';
import { DisplayBuildResult, displayToWorkloadsResultMapping, workloadsResultToDisplayMapping } from '@/views/workloads/workloads.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'statusFilter',
  setup(__props) {

const matomo = useMatomo();
const workloadStatusSelectOptions = computed(() => Object.values(Builds_BuildResult).map((status: Builds_BuildResult) => workloadsResultToDisplayMapping[status]));
const workloadsPageData = inject(IKWorkloadsPageData);
const modelValue = ref(workloadsPageData?.filter?.get?.value?.buildResult as Builds_BuildResult[]);

const mapStatusToDisplay = (status: Builds_BuildResult[]) => status.map((item: Builds_BuildResult) => workloadsResultToDisplayMapping[item]);
const handleSubmitFilter = () => {
  workloadsPageData?.filter?.setBuildResult(modelValue.value);
  matomo?.trackEvent({
    category: 'Workloads Filter',
    action: 'Apply  Status',
  });
};

const handleSelection = (selection: []) => {
  modelValue.value = selection.map((status: DisplayBuildResult) => displayToWorkloadsResultMapping[status]);
  if (modelValue.value.length === 0) {
    handleSubmitFilter();
  }
};

watch(
  () => workloadsPageData?.filter?.get?.value?.buildResult,
  (newValue: any) => {
    modelValue.value = newValue;
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediSelect), {
        items: _unref(workloadStatusSelectOptions) as any,
        "model-value": mapStatusToDisplay(modelValue.value) as any,
        size: "tiny",
        design: "ghost",
        direction: "bottom-sticky-left",
        label: "Status",
        multiple: "",
        clearable: "",
        "list-min-width": 136,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (selection) => handleSelection(selection)),
        onSubmit: _cache[1] || (_cache[1] = ($event: any) => (handleSubmitFilter()))
      }, null, 8, ["items", "model-value"])
    ]),
    _: 1
  }))
}
}

})